/* eslint-disable new-cap */
import { Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class SelectionSpot extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} game 
   * @param {*} x 
   * @param {*} y 
   * @param {*} number 
   */
  constructor(game, x, y, number) {
    super(game, x, y);

    this.sprite = game.add.sprite(0, 0, Images.DEFAULT_ATLAS, 'blankSpace');

    this.add(this.sprite);
    this.sprite.setOrigin(.5);
    this.y = y;
    this.counter = 0;
    this.number = number;
    this.step = Math.PI * 2 / 360;
    this.isPopulated = false;
    this.meteor = null;
  }

  Update(i) {
    const tStep = Math.sin(this.counter + (i * 1.5));
    this.y = tStep * 0.3 + this.y;
    this.counter += this.step * 2;
  }

  Destroy() {
    // this.sprite.alpha = 0;
    Tweens.addTween(this.sprite, 500, { scale: 1.2 }, Phaser.Math.Easing.Circular.Out, () => {
      if (this.meteor !== null) {
        this.meteor.Explode();
      }

      Tweens.addTween(this.sprite, 200, { alpha: 0 }, Phaser.Math.Easing.None);
    });
  }

  GetCoords() {
    return { x: this.x, y: this.y };
  }

  IsPopulated() {
    return this.isPopulated;
  }

  GetNumber() {
    return this.number;
  }

  SetMeteor(meteor, posDiff) {
    this.isPopulated = true;
    const meteorSprite = meteor.GetSprite();

    this.add(meteorSprite);
    meteorSprite.x = -posDiff.x;
    meteorSprite.y = -posDiff.y;
    meteor.LockAnimation();
    this.meteor = meteor;
  }
}